import { picoapp, component } from "picoapp";
import vsbl from "vsbl";
import choozy from "choozy";

const posts = component((node, ctx) => {
	const dom = choozy(node);

	dom.post.forEach((post) => {
		const enter = () => {
			post.classList.add('is-visible');
		}
		const exit = () => false;

		post.classList.add('is-animated');
		const listener = vsbl(post)(enter, exit);
	});
});

const app = picoapp({ posts });

document.addEventListener("turbolinks:load", function () {
	app.unmount();
	app.mount();
})